/* eslint-disable */
import { StyleSheet } from 'react-native'
import { ApplicationStyles } from '../../Themes/'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: {
    flex: 1

  },
  dark :{
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',

    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  absolute: {
    overflow: `hidden`,
    position: 'absolute',
    top: 0,
    left: 0,
    bottom : 0,
    right: 0,
  },
  main: {
    flex  : 1, /* was flexGrow for mobile but not scrolling on web */



  },
  shadow : {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.9,
    shadowRadius: 2,

  },
  searchContainer: {
    // backgroundColor: '#ff0',
    justifyContent: 'center'
  },
  searchInput: {
    fontSize: 14,
    borderColor: '#d6d2d9',
    borderWidth: 1,
    height: 35,
    backgroundColor: '#fff',
    margin: 5,
    borderRadius: 3
  },
  tabContainer: {
    flex: 1,
    flexDirection: 'row'
  },
  iconContainer: {
    position: 'absolute',
    right: 10,
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 0,
    backgroundColor: '#d6d2d9',
    justifyContent: 'center',
    alignItems: 'center'

  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover'

  },
  textTabContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',


  },

  textTabTitle: {

    fontSize: 15,
    backgroundColor: 'rgba(0,0,0,0)',
    color: 'white',
    fontWeight: 'bold',
    alignSelf: 'center'
  },
  tabButton: {
    flex: 1
  },
  tabContent: {
    flex: 1,

  },
  animatedHeader:
    {
      flexDirection: 'row',

      width: '100%'
    },





})
